var portfolioHeader = {
	baseCurrency: "Base currency",
	numberOfPositions: "Positions",
	portfolioValue: "Portfolio value in {currency}",
	todayChange: "Today change",
	unrealizedPerformance: "Unrealized perf.",
	purchaseValue: "Purchase value",
	realizedProfits: "Realized profits",
	totalValue: "Total value",
	totalPerformance: "Total perf.",
	lastCalculationDateTime: "Last calc."
};
var en = {
	portfolioHeader: portfolioHeader
};

export { en as default, portfolioHeader };
